import { Box, Link, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { clearStorage } from "utils/clear-storage.util";
import { logClientEvent } from "utils/client-log.util";

// After this long on the splash, give the user a way out instead of an
// endless logo screen (the app shell has no logout button here).
const SLOW_HINT_MS = 60000;

function hasStoredUser() {
  return Boolean(sessionStorage.getItem("user") || localStorage.getItem("user"));
}

const SplashScreen = () => {
  const theme = useTheme();
  const [slow, setSlow] = useState(false);
  const subscriptionError = useSelector(
    (state) => state.account.subscriptionError
  );
  const showHint = slow || subscriptionError;

  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), SLOW_HINT_MS);
    return () => clearTimeout(timer);
  }, []);

  const handleReload = (e) => {
    e.preventDefault();
    logClientEvent({
      source: "App/Startup/SplashScreenReloadClicked",
      level: "Information",
      message: "User clicked Reload on slow splash screen",
    });
    window.location.reload();
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    // Log first, while the user is still in storage so the log has their email.
    // Don't let a slow network hold up the logout itself.
    await Promise.race([
      logClientEvent({
        source: "App/Startup/SplashScreenLogoutClicked",
        level: "Information",
        message: "User clicked Log out on slow splash screen",
      }),
      new Promise((resolve) => setTimeout(resolve, 2000)),
    ]);
    clearStorage();
    localStorage.removeItem("login");
    window.location.replace("/");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        bgcolor: theme.palette.secondary.main,
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }}
    >
      <Box
        component="img"
        width="200px"
        maxHeight="100%"
        src={theme.palette.mode === "dark" ? "/images/sooth_horizontal_on_dark.png" : "/images/sooth_horizontal_on_white.png"}
        alt="Sooth.fyi Logo"
      />
      {showHint && (
        <Typography variant="body2" color="text.secondary" textAlign="center" px={2}>
          {subscriptionError
            ? "We couldn't load your account details."
            : "This is taking longer than usual. Your network may be slow."}{" "}
          Please{" "}
          <Link href="#" onClick={handleReload}>
            reload
          </Link>
          {hasStoredUser() && (
            <>
              {" "}or{" "}
              <Link href="#" onClick={handleLogout}>
                log out
              </Link>{" "}
              and sign in again
            </>
          )}
          .
        </Typography>
      )}
    </Box>
  );
};

export default SplashScreen;
